const allSubscriptionsQuery = `query GetAllSubscriptions {
  subscription {
    subscriptions {
      identifier
      subscriptionType
    }
  }
}`;

const generateQuery = () => {
	return {
		query: allSubscriptionsQuery,
	};
};

export default generateQuery;
